
import OidcClient from 'oidc-client';

export default {
    UserManager: null,
    configureUserManager: function(config) {
        this.UserManager = new OidcClient.UserManager({
            authority: config['OIDC_AUTHORITY'],
            client_id: config['OIDC_CLIENT_ID'],
            post_logout_redirect_uri: config['HOME_URL'],
            response_type: 'code',
            scope: 'openid profile email',
            loadUserInfo: true,
            automaticSilentRenew: true,
            silent_redirect_uri: config['SILENT_RENEW_URL'],
            silentRequestTimeout: 40000
        })
    },
}
